module.exports = __webpack_public_path__ + "img/ellipse-inside-blur.99b1787f.svg";